module.exports = __webpack_public_path__ + "static/media/19ESCAP38.945e4be4.jpg";